module.exports = __webpack_public_path__ + "images/Env3-2c820444ff16180c8ca39380857544be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/Env3.jpg
// module id = 39
// module chunks = 0